import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

import DataTable from "../../../components/common/datatable/DataTable";
import { DateComparator } from "../../../components/common/DateComparator";

const SchedulerTable = (props) => {
  const [headerItems, setHeaderItems] = useState(null);

  const commonFilterParams = useMemo(
    () => ({
      filterOptions: ["contains", "startsWith", "endsWith"],
      defaultOption: "contains",
    }),
    []
  );

  useEffect(() => {
    setHeaderItems([
      {
        headerName: "ID",
        field: "jobSeqId",
        sortable: true,
        resizable: false,
        filterParams: commonFilterParams,
        filter: "agTextColumnFilter",
        suppressMovable: true,
        unSortIcon: true,
        width:150
      },
      {
        headerName: "Plant",
        field: "plant",
        sortable: true,
        resizable: false,
        filterParams: commonFilterParams,
        filter: "agTextColumnFilter",
        suppressMovable: true,
        unSortIcon: true,
        width:150
      },
      {
        headerName: "Label",
        field: "scheduleLabel",
        sortable: true,
        resizable: false,
        filterParams: commonFilterParams,
        filter: "agTextColumnFilter",
        suppressMovable: true,
        unSortIcon: true,
      },
      {
        headerName: "Description",
        field: "scheduleDescription",
        sortable: true,
        resizable: false,
        filterParams: commonFilterParams,
        filter: "agTextColumnFilter",
        suppressMovable: true,
        unSortIcon: true,
      },
      {
        headerName: "Schedule Type",
        field: "scheduleType",
        sortable: true,
        resizable: false,
        filterParams: commonFilterParams,
        filter: "agTextColumnFilter",
        suppressMovable: true,
        unSortIcon: true,

      },
      {
        headerName: "Frequency",
        field: "frequency",
        sortable: true,
        resizable: false,
        filterParams: commonFilterParams,
        filter: "agTextColumnFilter",
        suppressMovable: true,
        unSortIcon: true,
      },
      {
        headerName: "Status",
        field: "status",
        sortable: true,
        resizable: false,
        filterParams: commonFilterParams,
        filter: "agTextColumnFilter",
        suppressMovable: true,
        unSortIcon: true,
        cellRenderer: (params) => {
          return (
            <Link
              href="#"
              style={{ color: "#000", cursor: "pointer"}}
              onClick={() => {
                props?.handleJobRunDetails(params?.data?.jobSeqId);
              }}
            >
              {params?.data?.status}
            </Link>
          );
        },
      },
      {
        headerName: "Started at",
        field: "startTsp",
        sortable: true,
        resizable: false,
        filterParams: commonFilterParams,
        comparator: DateComparator,
        // filter: 'agDateColumnFilter',
        suppressMovable: true,
        unSortIcon: true,
      },
      {
        headerName: "Action",
        resizable: false,
        filter: false,
        suppressMovable: true,
        unSortIcon: true,
        hide: props?.userRole === "Viewer" ? true : false,
        cellRenderer: (params) => {
          if (params?.data?.status !== "Scheduled") {
            return (
              <div style={{ marginTop: "7px" }}>
                <VisibilityIcon
                  sx={{ cursor: "pointer" }}
                  onClick={props?.viewJobHandler}
                />
              </div>
            );
          } else if (params?.data?.status !== "Cancelled") {
            return (
              <div style={{ marginTop: "7px" }}>
                <DeleteIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    props?.handleCancelledJob(params?.data?.jobSeqId)
                  }
                />
                <VisibilityIcon
                  sx={{ cursor: "pointer" }}
                  onClick={props?.viewJobHandler}
                />
              </div>
            );
          }
        },
      },
    ]);
  }, [commonFilterParams, props]);

  const defaultColDef = {
    sortable: true,
    filter: "agSetColumnFilter",
    autoHeight: true,
    cellStyle: {
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: 1.5,
      display: "flex",
      alignItems: "center",
    },
  };

  return (
    <>
      <DataTable
        columns={headerItems}
        rows={props?.allFetchedScheduledJobs || []}
        defaultColDef={defaultColDef}
        paginationProp={true}
      />
    </>
  );
};

export default SchedulerTable;
